module.exports = __webpack_public_path__ + "img/tecnici_info.d348f444.png";